import { Box, Button } from '@mui/material';
import { styled } from 'styled-components';
import pallet from '../../../layouts/pallet';

export const TabButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  overflow: 'auto',
  height: '42px'
}));

export const StyledButton = styled(Button).attrs((props: any) => ({
  variant: 'contained',
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor,
    boxShadow: props.$isActive
      ? `0px 2px 4px 0px ${pallet.buttonShadow}`
      : 'none'
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
  $isActive?: boolean;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap'
});

export const RenderTabContentBox = styled(Box)(() => ({
  height: 'inherit',
  width: '100%'
}));

export const AlertButton = styled(Button).attrs({ variant: 'contained' })({
  backgroundColor: `${pallet.red2} !important`,
  color: pallet.white,
  borderRadius: '4px !important',
  height: '30px !important',
  width: '115px !important',
  textAlign: 'center',
  paddingLeft: '22px !important',
  '&:hover': {
    backgroundColor: `${pallet.unlinkRed} !important`
  },
  '& .css-1v1j2p3-MuiButton-startIcon': {
    marginRight: '4px'
  }
});
